/**
 * @file paddle Hackathon
 * @author wanzhongyun
 */

import React, { useEffect, useState } from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';

import HackBanner from './components/hackBanner/HackBanner';
import HackLight from './components/hackLight/HackLight';
import HackTimeLine from './components/hackTimeLine/HackTimeLine';
import HackTopic from './components/hackTopic/HackTopic';
import HackAwards from './components/hackAwards/HackAwards';
import HackRegister from './components/hackRegister/HackRegister';
import HackPartner from './components/hackPartner/HackPartner';
import HackFixed from './components/hackFixed/HackFixed';
import { Spin } from 'antd';

import usePaddleHackathonHooks from './PaddleHackathonHook';


const PaddleHackathon: React.FC = () => {

    const {
        hackBanner,
        hackLight,
        hackTimeLine,
        hackTopic,
        hackAwards,
        hackRegister,
        hackQRCode,
        paddleHackathonPartner
    } = usePaddleHackathonHooks();

    const [loadingStatus, setLoadingStatus] = useState<boolean>(true);

    useEffect(() => {
        setTimeout(() => {
            setLoadingStatus(false);
        }, 1000);
    }, []);
    return (
        <div>
            <Header />
            <Spin spinning={loadingStatus} size="large">
                <HackBanner {...hackBanner} />

                <div className="paddle-hackathon-wrapper">
                    <div className='background-comman background-1' />
                    <div className='background-comman background-2' />
                    <div className='background-comman background-3' />
                    <div className='background-comman background-4' />
                    <div className='background-comman background-5' />
                    <div className='background-comman background-6' />
                    <div className='background-comman background-7' />
                    <HackLight {...hackLight} />
                    <HackTopic {...hackTopic} />
                    <HackTimeLine {...hackTimeLine} />
                    <HackAwards {...hackAwards} />
                    <HackRegister  {...hackRegister} />
                    <HackPartner {...paddleHackathonPartner} />
                    <HackFixed {...hackQRCode} />
                </div>
            </Spin>

            <Footer />
        </div>
    );
};

export default React.memo(PaddleHackathon);
